import { jsx as _jsx } from "react/jsx-runtime";
import { useMergeRefs } from '@floating-ui/react';
import React from 'react';
import { useDropdownContext } from '../../contexts/Dropdown';
import Button from '../Button';
export const DropdownToggle = React.forwardRef(({ children, size, asChild, as, ...props }, forwardedRef) => {
    const { isOpen, refs, getReferenceProps } = useDropdownContext();
    // eslint-disable-next-line
    const childrenRef = children?.ref;
    const ref = useMergeRefs([refs.setReference, forwardedRef, childrenRef]);
    if (asChild && React.isValidElement(children)) {
        return React.cloneElement(children, getReferenceProps({
            ref,
            ...props,
            ...children.props,
            'data-open': isOpen,
        }));
    }
    const Component = as || Button;
    return (_jsx(Component, { ref: ref, size: size, "data-open": isOpen, ...getReferenceProps(props), children: children }));
});
DropdownToggle.displayName = 'DropdownToggle';
export default DropdownToggle;
